<div id="webcamImage" class="loader_webcam" *ngIf="webcamImage">
  <img [src]="webcamImage" alt="">
  <div class="webcam_btns f_center">
    <fa-icon icon="circle-xmark" (click)="close()"></fa-icon>
    <fa-icon icon="circle-check" (click)="confirm()"></fa-icon>
  </div>
</div>
<div *ngIf="showCamera">
  <app-webcam backUrl="selfie-payment" (output)="setPicture($event)"></app-webcam>
</div>
